export default __webpack_public_path__ + "static/media/SAICE-EducationTraining.c66694ec.png";